import PropTypes from "prop-types";
import React from "react";
import { injectIntl, intlShape } from "react-intl";
import { Table } from "@yoast/ui-library";

import SiteSubscriptionRow from "../SiteSubscriptionRow";

/**
 * Renders a subscriptions component.
 *
 * @param {Object} props The props to use.
 * @returns {ReactElement} The rendered Subscriptions component.
 */
function SiteSubscriptions( props ) {
	const onToggleDisabled = ( sourceId ) => {
		const plugin = props.plugins.findLast( ( p ) => p.sourceId === sourceId );
		return props.onToggleDisabled( plugin ? plugin.storeUrl : "" );
	};

	/*
	 * Rows of products that have not been purchased only need to reserve space for a
	 * toggle when another row actually shows one, otherwise every icon would be
	 * indented by the toggle's width without a toggle in sight.
	 */
	const anyPluginHasSubscriptions = props.plugins.some( ( plugin ) => plugin.hasSubscriptions );

	return (
		<>
			<Table>
				<Table.Body>
					{ props.plugins.map( ( plugin ) =>
						<SiteSubscriptionRow
							{ ...plugin }
							key={ plugin.glNumber || plugin.id }
							onMoreInfoClick={ props.onMoreInfoClick }
							onToggleDisabled={ onToggleDisabled }
							onToggleSubscription={ props.onToggleSubscription }
							togglingSubscription={
								Boolean( plugin.subscriptionId ) &&
								props.togglingSubscriptionIds.includes( plugin.subscriptionId )
							}
							modalOpen={ props.modalOpen }
							onClose={ props.onClose }
							onShop={ plugin.storeUrl }
							reserveToggleSpace={ anyPluginHasSubscriptions }
						/>,
					) }
				</Table.Body>
			</Table>
		</>
	);
}

SiteSubscriptions.propTypes = {
	plugins: PropTypes.arrayOf( PropTypes.object ),
	togglingSubscriptionIds: PropTypes.arrayOf( PropTypes.string ),
	intl: intlShape.isRequired,
};

SiteSubscriptions.defaultProps = {
	activeSubscriptions: [],
	plugins: [],
	togglingSubscriptionIds: [],
};

export default injectIntl( SiteSubscriptions );
